import { array, object, string } from "yup"

export const FIELDS_NAME = {
   NAME: "name",
   HOURS: "hours",
   STATION: "station",
}

export const initialValues = {
   [FIELDS_NAME.NAME]: "",
   [FIELDS_NAME.HOURS]: null,
   [FIELDS_NAME.STATION]: null,
}

export const stageValidationSchema = object({
   [FIELDS_NAME.NAME]: string()
      .required("Stage name is required")
      .max(50, "Stage name can not exceed 50 characters"),
   [FIELDS_NAME.HOURS]: object({
      label: string().required("Station name is required"),
      value: string().required("Station value is required"),
   })
      .nullable()
      .required("Stage hours is required"),

   [FIELDS_NAME.STATION]: array()
      .nullable()
      .of(
         object({
            label: string().required("Station name is required"),
            value: string().required("Station value is required"),
         })
      )
      .required("Station is required"),
})
